import React, { useState, useRef, useEffect } from 'react';

import { App } from '../../app/AppSingleton';
import './ColumnAdd.css';

const ColumnAdd: React.FC = () => {
	const [isAdding, setIsAdding] = useState(false);
	const [title, setTitle] = useState('');
	const [error, setError] = useState('');
	const inputRef = useRef<HTMLInputElement>(null);
	const app = App.getInstance();

	const handleAddClick = () => {
		setIsAdding(true);
		setTitle('');
		setError('');
	};

	const handleSave = () => {
		if (!title.trim()) {
			setError('Название колонки не может быть пустым');
			return;
		}

		try {
			app.columnAdd(title.trim());
			setIsAdding(false);
			setTitle('');
			setError('');
		} catch (err) {
			setError(err instanceof Error ? err.message : 'Ошибка при добавлении колонки');
		}
	};

	const handleCancel = () => {
		setIsAdding(false);
		setTitle('');
		setError('');
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') {
			handleSave();
		} else if (e.key === 'Escape') {
			handleCancel();
		}
	};

	// Автофокус при открытии
	useEffect(() => {
		if (isAdding && inputRef.current) {
			inputRef.current.focus();
		}
	}, [isAdding]);

	if (!isAdding) {
		return (
			<button
				onClick={handleAddClick}
				className="column-add-button"
			>
				<div className="column-add-button__content">
					<div className="column-add-button__icon">+</div>
					<div className="column-add-button__text">Добавить колонку</div>
				</div>
			</button>
		);
	}

	return (
		<div className="column-add-form">
			<div className="column-add-form__input-container">
				<input
					ref={inputRef}
					type="text"
					value={title}
					onChange={e => setTitle(e.target.value)}
					onKeyDown={handleKeyDown}
					placeholder="Введите название колонки"
					className="column-add-form__input"
					maxLength={50}
				/>

				{error && <div className="column-add-form__error">{error}</div>}
			</div>

			<div className="column-add-form__buttons">
				<button
					onClick={handleSave}
					className="column-add-form__button column-add-form__button--add"
				>
          Добавить
				</button>

				<button
					onClick={handleCancel}
					className="column-add-form__button column-add-form__button--cancel"
				>
          Отмена
				</button>
			</div>
		</div>
	);
};

export default ColumnAdd;
